/**
 * Names of the Keycloak session cookies. They are published on the shared root domain
 * (`.odys.travel`), so every app on a subdomain reads the same three values — which is
 * exactly why they must be named in one place and never re-declared per app.
 *
 * The *legacy* Softr-era cookie is deliberately NOT here: it differs per app
 * (`jwtToken` in odys, `odysToken` in onboarding, `quotationToken`/`agencyToken` in
 * quotation). Each app declares its own and passes it to the helpers that need it.
 */

export const KEYCLOAK_TOKEN_COOKIE = "keycloakToken";
export const REFRESH_TOKEN_COOKIE = "refreshToken";

/**
 * Carries the page a DMC started from across the catalog → odys hand-over.
 *
 * A DMC who lands on the agency mire clicks "Sign in with your Odys account", which leaves the
 * `catalog` realm entirely for odys's login BFF. By then the `?return=` catalog captured is
 * sealed inside catalog's host-only flow cookie and its `state`, invisible to the Keycloak theme
 * that renders the hand-over link — so the destination cannot ride the redirect.
 *
 * Catalog instead drops this value on the shared root domain (`.odys.travel`) when it starts the
 * login, and odys's BFF reads it as a fallback return when no explicit `?return=` is given. It is
 * a transient hint, not a session: short-lived, only written for a real starting page (never for
 * the bare home), re-validated by `resolveReturnTo` on read (so only a sibling `*.odys.travel`
 * HTTPS origin survives), and cleared by whoever concludes the login — odys the first time it
 * sees it, Catalog when the login ends inside Catalog and no hand-over happened.
 *
 * The name lives here with the other cookie names, but nothing writes it directly: the three
 * routes involved go through `authority/dmc-handover.ts`, so the attributes a clear has to match
 * cannot drift between the writer and the reader.
 */
export const DMC_HANDOVER_RETURN_COOKIE = "dmcHandoverReturnTo";
